<template>
  <v-app id="inspire" :dark="$store.getters.isDarkTheme" v-resize="onResize">

    <!-- Mensaje de bienvenida a la app -->
    <!-- <app-not-visited-before></app-not-visited-before> -->

    <!-- Menú lateral principal -->
    <app-navigation-drawer></app-navigation-drawer>

    <v-toolbar app fixed ref="toolbar" color="primary" class="elevation-3">
      <v-toolbar-side-icon
        :disabled="$store.getters.isLoading || !!$store.getters.activeControlId == true"
        @click.stop="$store.dispatch('toggleMenu')"></v-toolbar-side-icon>
      <v-toolbar-title>{{ $t('indicadores-ambientales') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <app-select-language></app-select-language>
    </v-toolbar>
    <v-content>

      <!-- Contenedor del Mapa (Rellena el alto) -->
      <div ref="mapContainer">
        <!-- Barra cargando -->
        <div ref="progress" style="position: absolute; z-index: 2; width: 100%;top: 0;">
          <v-progress-linear 
            v-show="$store.getters.isLoading"
            v-bind:indeterminate="true"
            height="5"
            class="mb-0 mt-0">
          </v-progress-linear>
        </div>

        <!-- Mapa Principal - Componente - -->
        <app-map ref="appMap"></app-map>

      </div>

      <!-- SnackBar posibles errores -->
      <v-snackbar
        :timeout="3000"
        absolute
        top
        v-model="hasError"
      >
        {{$store.getters.errorMessage}}
        <v-btn class="error--text" dark flat @click.native="$store.dispatch('clearError')">{{ $t('cerrar') }}</v-btn>
      </v-snackbar>

      <!-- SnackBar de información -->
      <v-snackbar
        :timeout="0"
        absolute
        top
        v-model="hasInfo"
      >
        {{$store.getters.infoMessage}}
      </v-snackbar>

      <v-footer app inset color="primary">
        <div class="pa-3">&copy; {{(new Date()).getFullYear()}} GreenUrbanData</div>
      </v-footer>
    </v-content>
  </v-app>
</template>


<script>
import AppMap from '@/components/Map'
import AppNavigationDrawer from '@/components/main/NavigationDrawer'
import AppSelectLanguage from '@/components/main/SelectLanguage'

import colors from 'vuetify/es5/util/colors'
import config from './config'

import * as GSRest from './api/gsrest'

/**
 * Componente principal
 */
export default {

  components: {
    AppNavigationDrawer,
    AppMap,
    AppSelectLanguage
  },

  computed: {
    hasError: {
      get() { return this.$store.getters.hasError },
      set() { this.$store.dispatch('clearError') }
    },
    hasInfo: {
      get() { return this.$store.getters.hasInfo },
      set() { this.$store.dispatch('clearInfo') }
    },

    indicadores() {
      return this.$store.getters.indicadores
    },
    indicador: {
      get() { return this.$store.getters.indicador },
    },

    period: {
      get() { return this.$store.getters.period },
      set(period) { this.$store.dispatch('setPeriod', period) }
    }
  },

  async created() {
    this.$watch(() => this.$store.getters.locale, this.onLocaleChange)
    this.$watch(() => this.indicador, this.onIndicadorChange)

    // document.title = this.$t('indicadores-ambientales')
    this.onThemeChanged(this.$store.getters.isDarkTheme)

    const AllLayers = await GSRest.getLayersFromWorkspace(config.geoserver.geoserverWorkspace)
    //console.log(AllLayers)
    const indicadoresNames = GSRest.getIndicadoresNames(AllLayers)
    const savedPolygons = JSON.parse(localStorage.getItem('saved-polygons'))

    this.$store.dispatch('setLayers', AllLayers)

    if(savedPolygons){
      savedPolygons.forEach(poly => this.$store.dispatch('addPolygon', poly))
      localStorage.removeItem('saved-polygons')
    }

    indicadoresNames.forEach(key => {
      const layers = GSRest.getOrderedLayersOf(AllLayers, key)
      this.$store.dispatch('addIndicador', [key, layers])
    })

    const [firstIndicator] = indicadoresNames

    this.$store.dispatch('changeIndicador', firstIndicator)
  },

  mounted(){
    this.$watch(() => this.$refs.toolbar.computedHeight, this.onResize)
    this.$watch(() => this.$store.getters.isDarkTheme, this.onThemeChanged)
    
    this.$refs.mapContainer.style.height = 'calc(100vh - ' + this.$refs.toolbar.computedHeight + 'px - 36px)'
    // this.$refs.progress.style.top = this.$refs.toolbar.computedHeight + 'px'
  },

  methods: {

    onIndicadorChange() {
      const localize = str => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
      const layers = this.indicadores[this.indicador]

      let validPeriods = Object.entries(
        ['anual', 'mensual', 'trimestral'].reduce((obj, period) => {
          const numLayers = layers.filter(({name}) => name.includes(period)).length
          obj[period] = numLayers
          return obj 
        }, {})
      )
      .filter(([key, value]) => value > 0)
      .map(([key, value]) => localize(key))
  
      this.period = validPeriods[0]
    },

    onResize() {
      this.$refs.mapContainer.style.height = 'calc(100vh - ' + this.$refs.toolbar.computedHeight + 'px - 36px)'
      // this.$refs.progress.style.top = this.$refs.toolbar.computedHeight + 'px'
    },

    onThemeChanged(isDark) {

      let theme

      if(isDark) {
        theme = {
          primary: colors.lightGreen.base,
          secondary: colors.lightGreen.lighten2,
          accent: colors.orange.base,
          error: colors.red.base,
          warning: colors.yellow.base,
          info: colors.blue.base,
          success: colors.green.base
          
        }
      } else {
        theme = {
          primary: colors.green.base,
          secondary: colors.green.lighten2,
          accent: colors.amber.base,
          error: colors.red.base,
          warning: colors.yellow.base,
          info: colors.blue.base,
          success: colors.green.base

        }
      }

      this.$vuetify.theme = theme
    },

    onLocaleChange(locale) {
      this.$i18n.locale = locale.key
      document.title = this.$t('indicadores-ambientales')
    }
  },
}
</script>

<style>
html, body {
  overflow: hidden;
}

</style>





// WEBPACK FOOTER //
// App.vue?e967172c